<template>
  <div id="app">
    <Header />
    <div class="container-fluid no-gutters p-0">
      <Carousel />
      <div data-target="#navbar" data-offset="0">
        <About />
        <Services />
        <Team />
        <OurCredentials />
        <Customers />
        <!--<Contact />-->
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import OurCredentials from './components/OurCredentials.vue'
import Carousel from './components/Carousel.vue'
import About from './components/About.vue'
import Services from './components/Services.vue'
import Team from './components/Team.vue'
//import Customers from './components/Customers.vue'
//import Contact  from './components/Contact.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Header,
    OurCredentials,
    Carousel,
    About,
    Services,
    Team,
    //Customers,
    // Contact,
    Footer
  }
}
</script>

<style>

</style>
